import React from 'react';
import PropTypes from 'prop-types';

import * as S from './advert-tile.module.scss';

import { useGlobalCtx } from '../../../../context/ctx-hook';

import { BmAdvert } from '../tile-bm/bm-advert';
import { QobAdvert } from '../tile-qob/qob-advert';
import { QemAdvert } from '../tile-qem/qem-advert';


const AdvertTile = ({ productLineAds }) => {
  // const { state } = useGlobalCtx();
  // const { productLineAds } = props;
  // console.log(productLineAds);
  // console.log(productLineAds[0]);
  // console.log(typeof(productLineAds));
  // console.log(productLineAds.includes('billmanager'));

  return (
    <div className={S.advertContain} data-testid="ADVERT_CONTAINER">
      <div className={S.sectionTitle}>
        <h3>Perfect add-ons for you</h3>
      </div>

      <div className={`${S.adverts}`} data-testid="ADVERT_TILE_QEM">
        {productLineAds.includes('quicken-estate-manager') &&
          <div className={`${S.advertTile}`}>
            <QemAdvert />
          </div>
        }

        {productLineAds.includes('billmanager') &&
          <div className={`${S.advertTile}`} data-testid="ADVERT_TILE_BM">
            <BmAdvert />
          </div>
        }

        {productLineAds.includes('quicken-online-backup') &&
          <div className={`${S.advertTile}`} data-testid="ADVERT_TILE_QOB">
            <QobAdvert />
          </div>
        }
      </div>
    </div>
  );
};

AdvertTile.displayName  = 'advertTile';
AdvertTile.propTypes    = {
  productLineAds: PropTypes.array
};

AdvertTile.defaultProps = {
  productLineAds: []
};

export { AdvertTile };